export default __webpack_public_path__ + "static/media/BartolomeoRegular.59fb101b.ttf";